<!-- filepath: /d:/Area de Trabalho/criandoparaweb/site/src/components/GoogleAds.vue -->
<template>
  <div>
    <Navbar />
    <HeroSection />
    <BenefitsSection />
    <CTASection />
    <ServicesSection />
    <TestimonialsSection />
    <PricingSection />
    <ContactSection />
    <Footer />
  </div>
</template>

<script setup>
import { onMounted } from 'vue';
import Navbar from './Navbar.vue';
import HeroSection from './HeroSection.vue';
import ServicesSection from './ServicesSection.vue';
import CTASection from './CTASection.vue';
import Preloader from './Preloader.vue';
import BenefitsSection from './BenefitsSection.vue';
import TestimonialsSection from './TestimonialsSection.vue';
import PricingSection from './PricingSection.vue';
import Footer from './Footer.vue';
import ContactSection from './ContactSection.vue';
import ClientsSection from './ClientsSection.vue';

onMounted(() => {
  document.title = 'Gestão de Google Ads Profissional | Atraia Mais Clientes com Anúncios Eficientes - Criando para Web';
  const metaDescription = document.querySelector('meta[name="description"]');
  if (metaDescription) {
    metaDescription.setAttribute('content', 'Maximize seus resultados com nossa gestão especializada de Google Ads. Criamos campanhas estratégicas para atrair mais clientes e aumentar suas vendas. Solicite uma consultoria gratuita! 🚀');
  } else {
    const meta = document.createElement('meta');
    meta.name = 'description';
    meta.content = 'Maximize seus resultados com nossa gestão especializada de Google Ads. Criamos campanhas estratégicas para atrair mais clientes e aumentar suas vendas. Solicite uma consultoria gratuita! 🚀';
    document.head.appendChild(meta);
  }
});
</script>

<style scoped>
/* Adicione estilos específicos para este componente, se necessário */
</style>